import { css } from 'styled-components';
import { BACKGROUND_COLOR, BORDER_COLOR, BORDER_RADIUS, BORDER_WIDTH, ROOT_GAP, ROOT_HEIGHT, ROOT_PADDING_LEFT, ROOT_PADDING_RIGHT, ROOT_PADDING_VERTICAL, } from '../tokens';
import { getTypeSpec } from '../utils';
export const rootBackgroundColor = ({ disabled }) => disabled ? BACKGROUND_COLOR.DISABLED : BACKGROUND_COLOR.DEFAULT;
export const rootBorder = () => css `
  border-width: ${rootBorderWidth}px;
  border-style: solid;
  border-color: ${rootBorderColor};
  border-radius: ${BORDER_RADIUS}px;
`;
export const rootBorderColor = ({ disabled, focused, validationState, }) => {
    if (validationState === 'error')
        return BORDER_COLOR.ERROR;
    if (validationState === 'valid')
        return BORDER_COLOR.SUCCESS;
    if (focused)
        return BORDER_COLOR.FOCUSED;
    if (disabled)
        return BORDER_COLOR.DISABLED;
    return BORDER_COLOR.DEFAULT;
};
export const rootBorderWidth = ({ focused }) => {
    if (focused)
        return BORDER_WIDTH.FOCUSED;
    return BORDER_WIDTH.DEFAULT;
};
export const rootBoxModel = () => css `
  box-sizing: border-box;
  width: 100%;
  min-height: ${rootHeight}px;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  ${rootPadding};
`;
export const rootGap = ({ fieldSize = 'md' }) => {
    return ROOT_GAP[fieldSize];
};
export const rootHeight = ({ fieldSize = 'md', rows, }) => {
    if (rows) {
        const { fontSize } = getTypeSpec(fieldSize);
        const extraItemsHeight = (rows - 1) * fontSize;
        return (ROOT_HEIGHT[fieldSize] +
            ROOT_PADDING_VERTICAL[fieldSize] * 2 +
            extraItemsHeight);
    }
    return ROOT_HEIGHT[fieldSize];
};
export const rootPadding = ({ fieldSize = 'md', focused, rows, }) => {
    let padVertical = 0;
    if (rows) {
        padVertical = focused
            ? ROOT_PADDING_VERTICAL[fieldSize] - 1
            : ROOT_PADDING_VERTICAL[fieldSize];
    }
    const padLeft = focused
        ? ROOT_PADDING_LEFT[fieldSize] - 1
        : ROOT_PADDING_LEFT[fieldSize];
    const padRight = focused
        ? ROOT_PADDING_RIGHT[fieldSize] - 1
        : ROOT_PADDING_RIGHT[fieldSize];
    return css `
    padding: ${padVertical}px ${padRight}px ${padVertical}px ${padLeft}px;
  `;
};
